<template>
  <div class="treatments js">
    <div class="treatments-section">
      <!-- <div class="treatments-title-cont">
        <div class="treatments-title-cont-text animated fadeIn">
          <div class="treatments-title-cont-text1" data-animate data-animate-order="1">
            <h2>{{ solutionsList[0]?.value[0]?.title }}</h2>
          </div>
          <div class="treatments-title-cont-text2" data-animate data-animate-order="2">
            <p>{{ solutionsList[0]?.value[0]?.subheading }}</p>
          </div>
        </div>
      </div> -->
      <div class="treatments-content img-animate-up">
        <div class="item kb-animate-up animate-up">
          <img :src="treatmentsKomo?.left_img || require('@/assets/assetsNew/home/treatments1.png')"></img>
          <div class="content">
            <div class="">
              <h2 class="content-title">{{ treatmentsKomo?.left_img_title }}</h2>
            </div>
          </div>
        </div>
        <div class="item kb-animate-up animate-up">
          <img :src="treatmentsKomo?.right_img || require('@/assets/assetsNew/home/treatments2.png')"></img>
          <div class="content">
            <div class="">
              <h2 class="content-title">{{ treatmentsKomo?.right_img_title }}</h2>
            </div>
          </div>
        </div>
        <div class="item kb-animate-up animate-up">
          <div class="content">
          <div class="">
            <h2 class="content-title">{{ treatmentsKomo?.content_title }}</h2>
            <p v-html="treatmentsKomo?.conttent_content"></p>
          </div>
        </div>
        </div>
        <div class="item kb-animate-up animate-up">
          <img :src="treatmentsKomo?.top_img || require('@/assets/assetsNew/home/treatments3.png')"></img>
          <div class="content">
            <div class="">
              <h2 class="content-title">{{ treatmentsKomo?.top_img_title }}</h2>
            </div>
          </div>
        </div>
        <div class="item kb-animate-up animate-up">
          <img :src="treatmentsKomo?.down_img || require('@/assets/assetsNew/home/t.webp')"></img>
          <div class="content">
            <div class="">
              <h2 class="content-title">{{ treatmentsKomo?.down_img_title }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-cont1">
        <div class="treatments-cont1-cont" style="background: #e8e2d9;">
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-left kb-enabled in-viewport">
            <div>
              <div class="cont1-img">
                <div class="responsive-image-wrapper">
                  <img loading="lazy" 
                    class="theme-img js" 
                    style="object-fit:cover; 
                    object-position:50.0% 50.0%!important;" 
                    alt="" 
                    :width="984" 
                    :height="1229" 
                    :srcset="`${solutionsList[0]?.value[0]?.content[0]?.subheading_img} 550w, 
                              ${solutionsList[0]?.value[0]?.content[0]?.subheading_img} 750w, 
                              ${solutionsList[0]?.value[0]?.content[0]?.subheading_img} 984w`" 
                    sizes="100vw" 
                    :src="solutionsList[0]?.value[0]?.content[0]?.subheading_img"
                    v-if="solutionsList[0]?.value[0]?.content[0]?.subheading_img">
                  <!-- 占位符 -->
                  <!-- <div v-else class="image-placeholder">
                    <div class="placeholder-content">
                      <div class="placeholder-icon">ImageContext</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-right">
            <div>
              <div class="treatments-cont1-cont-right-inner animated fadeIn" v-html="solutionsList[0]?.value[0]?.content[0]?.detail"></div>
              <!-- <div class="" data-animate data-animate-order="3">
                  <h2>Scalp Care</h2>
                </div>
                <div class="treatments-cont1-cont-right-inner-rte" data-animate data-animate-order="4">
                  <h4>Scalp Oil Removal</h4>
                  <p>Gently melts away stubborn sebum and residue from scalp and follicles with triple botanical extracts, restoring clarity and balance.</p>
                  <h4>Cleansing and Hydrating</h4>
                  <p>Deeply cleanses, relaxes, and rebalances the scalp to restore its natural, healthy condition.</p>
                  <h4>Soothing</h4>
                  <p>Relieves sensitivity and strengthens the scalp barrier.</p>
                  <h4>Dandruff and Itch Relief</h4>
                  <p>Rebalances scalp microbiota, relieves itching, and restores comfort and cleanliness.</p>
                  <h4>Hair Strengthening</h4>
                  <p>Infused with KOMO’s signature essence to strengthen thinning hair and promote healthy growth.</p>
                  <h4>Oil Control</h4>
                  <p>Regulates sebum secretion through precision massage and intelligent device synergy, leaving the scalp fresh and the hair naturally lifted.</p>
                </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-section-kong">
        <div class="animated fadeIn"></div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-cont1">
        <div class="treatments-cont1-cont">
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-right cont2-right-bk">
            <div>
              <div class="treatments-cont1-cont-right-inner treatments-cont2-cont-right-inner animated fadeIn" v-html="solutionsList[0]?.value[0]?.content[1]?.detail">
              </div>
            <!-- <div class="" data-animate data-animate-order="3">
                  <h2>SPA</h2>
                </div>
                <div class="treatments-cont1-cont-right-inner-rte" data-animate data-animate-order="4">
                  <h4>Aromatherapy Hair SPA</h4>
                  <p>Gentle massage releases stress, improves scalp micro-circulation, and restores a calm balance between body and mind.</p>
                  <h4>Scalp &amp; Hair Nourishing SPA</h4>
                  <p>Using KOMO’s exclusive acupressure technique and hydrating cream, Stimulates meridian points, enhances blood flow, and replenishes scalp moisture and elasticity.</p>
                  <h4>Neck &amp; Shoulder Massage</h4>
                  <p>Blends KOMO’s body oil with gentle massage to ease stiffness and fatigue while complementing scalp care for full-body rejuvenation.</p>
                </div> -->
            </div>
          </div>
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-left kb-enabled in-viewport">
            <div>
              <div class="cont1-img">
                <div class="responsive-image-wrapper">
                  <img loading="lazy" 
                    class="theme-img js" 
                    style="object-fit:cover; 
                    object-position:50.0% 50.0%!important;" 
                    alt="" 
                    :width="984" 
                    :height="1229" 
                    :srcset="`${solutionsList[0]?.value[0]?.content[1]?.subheading_img} 550w, 
                              ${solutionsList[0]?.value[0]?.content[1]?.subheading_img} 750w, 
                              ${solutionsList[0]?.value[0]?.content[1]?.subheading_img} 984w`" 
                    sizes="100vw" 
                    :src="solutionsList[0]?.value[0]?.content[1]?.subheading_img"
                    v-if="solutionsList[0]?.value[0]?.content[1]?.subheading_img">
                  <!-- 占位符 -->
                  <!-- <div v-else class="image-placeholder">
                    <div class="placeholder-content">
                      <div class="placeholder-icon">ImageContext</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-section-kong">
        <div class="animated fadeIn"></div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-cont1">
        <div class="treatments-cont1-cont">
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-left kb-enabled in-viewport">
            <div>
              <div class="cont1-img">
                <div class="responsive-image-wrapper">
                  <img loading="lazy" 
                    class="theme-img js" 
                    style="object-fit:cover; 
                    object-position:50.0% 50.0%!important;" 
                    alt="" 
                    :width="984" 
                    :height="1229" 
                    :srcset="`${solutionsList[0]?.value[0]?.content[2]?.subheading_img} 550w, 
                              ${solutionsList[0]?.value[0]?.content[2]?.subheading_img} 750w, 
                              ${solutionsList[0]?.value[0]?.content[2]?.subheading_img} 984w`" 
                    sizes="100vw" 
                    :src="solutionsList[0]?.value[0]?.content[2]?.subheading_img"
                    v-if="solutionsList[0]?.value[0]?.content[2]?.subheading_img">
                  <!-- 占位符 -->
                  <!-- <div v-else class="image-placeholder">
                    <div class="placeholder-content">
                      <div class="placeholder-icon">ImageContext</div>
                      <div class="placeholder-text">图片加载中...</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-right cont3-right-bk">
            <div>
              <div class="treatments-cont1-cont-right-inner treatments-cont3-cont-right-inner animated fadeIn" v-html="solutionsList[0]?.value[0]?.content[2]?.detail"></div>
                <!-- <div class="" data-animate data-animate-order="4">
                  <h2>Hair Care</h2>
                </div>
                <div class="treatments-cont1-cont-right-inner-rte" data-animate data-animate-order="4">
                  <h4>Moisturizing Hair Repair Care</h4>
                  <p>Infused with KOMO hair essence and serum to seal, smooth, and illuminate strands with weightless shine.</p>
                  <h4>Nourishing Hair Repair Care</h4>
                  <p>Rebuilds hair cortex structure, and Reinforces strength and resilience for a silky, satin-like finish.</p>
                  <h4>Revitalizing Hair Repair Care</h4>
                  <p>Targeting the hair core, revitalizes from within, enhances elasticity, and restores lasting bounce and vitality.</p>
                </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-section-kong">
        <div class="animated fadeIn"></div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-cont1">
        <div class="treatments-cont1-cont">
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-right cont4-right-bk">
            <div>
              <div class="treatments-cont1-cont-right-inner treatments-cont4-cont-right-inner animated fadeIn" v-html="solutionsList[0]?.value[0]?.content[3]?.detail">
              </div>
              <!-- <div class="" data-animate data-animate-order="4">
                  <h2>Deep Care</h2>
                </div>
                <div class="treatments-cont1-cont-right-inner-rte" data-animate data-animate-order="4">
                  <h4>Hair Renewal</h4>
                  <p>Boosts follicle nutrition and reawakens dormant roots. Strengthens and thickens hair at its origin.</p>
                  <h4>Anti-Greying&nbsp;</h4>
                  <p>Preserves pigment and revives youthful radiance.</p>
                  <h4>Bi-Collagen Anti-Aging</h4>
                  <p>Featuring KOMO Bi-Collagen Essence to fortify follicles, reduce shedding, and promote visibly fuller, denser hair over time.</p>
                </div> -->
            </div>
          </div>
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-left kb-enabled in-viewport">
            <div>
              <div class="cont1-img">
                <div class="responsive-image-wrapper">
                  <img loading="lazy" 
                    class="theme-img js" 
                    style="object-fit:cover; 
                    object-position:50.0% 50.0%!important;" 
                    alt="" 
                    :width="984" 
                    :height="1229" 
                    :srcset="`${solutionsList[0]?.value[0]?.content[3]?.subheading_img} 550w, 
                              ${solutionsList[0]?.value[0]?.content[3]?.subheading_img} 750w, 
                              ${solutionsList[0]?.value[0]?.content[3]?.subheading_img} 984w`" 
                    sizes="100vw" 
                    :src="solutionsList[0]?.value[0]?.content[3]?.subheading_img"
                    v-if="solutionsList[0]?.value[0]?.content[3]?.subheading_img">
                  <!-- 占位符 -->
                  <!-- <div v-else class="image-placeholder">
                    <div class="placeholder-content">
                      <div class="placeholder-icon">ImageContext</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-section-kong">
        <div class="animated fadeIn"></div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-cont1">
        <div class="treatments-cont1-cont treatments-cont5-cont" style="background: #edeceb;">
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-right cont5-right-bk">
            <div>
              <div class="treatments-cont1-cont-right-inner treatments-cont5-cont-right-inner animated fadeIn" v-html="solutionsList[0]?.value[0]?.content[4]?.detail">
              </div>
              <!-- <div class="" data-animate data-animate-order="4">
                  <h2>Visible Progress after KOMO Treatments</h2>
                </div>
                <div class="treatments-cont1-cont-right-inner-rte" data-animate data-animate-order="4">
                  <p>
                    <strong>Before</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>Scalp</strong>: sparse follicles, thin hair.
                    </li>
                    <li>
                      <strong>Hair strands</strong>: dryness, split ends, breakage.
                    </li>
                  </ul>
                  <p>
                    <strong>After 3 Months</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>Scalp</strong>: visible follicle renewal and denser growth.
                    </li>
                    <li>
                      <strong>Hair strands</strong>: stronger, smoother, improved shine.
                    </li>
                  </ul>
                  <p></p>
                  <h6>
                    <em>Documented after 3 months of weekly Anti-Aging with Dual Collagen treatment. Results may vary by individual.
                    </em>
                  </h6>
                </div> -->
            </div>
          </div>
          <div class="treatments-cont1-cont-cont treatments-cont1-cont-left kb-enabled in-viewport">
            <div>
              <div class="cont1-img">
                <div class="responsive-image-wrapper responsive-image-wrapper5">
                  <img loading="lazy" 
                    class="theme-img js" 
                    style="object-fit:cover; 
                    object-position:50.0% 50.0%!important;" 
                    alt="" 
                    :width="984" 
                    :height="1229" 
                    :srcset="`${solutionsList[0]?.value[0]?.content[4]?.subheading_img} 550w, 
                              ${solutionsList[0]?.value[0]?.content[4]?.subheading_img} 750w, 
                              ${solutionsList[0]?.value[0]?.content[4]?.subheading_img} 984w`" 
                    sizes="100vw" 
                    :src="solutionsList[0]?.value[0]?.content[4]?.subheading_img"
                    v-if="solutionsList[0]?.value[0]?.content[4]?.subheading_img">
                  <!-- 占位符 -->
                  <!-- <div v-else class="image-placeholder">
                    <div class="placeholder-content">
                      <div class="placeholder-icon">ImageContext</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="treatments-section">
      <div class="treatments-section-kong">
        <div class="animated fadeIn"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBannerListing,getDataList } from '@/api/komo'
export default {
  data() {
      return {
        // bannerList: [],
        solutionsList: [],
        treatmentsKomo: {},
      }
  },
  async created () {
    await this.initData();
  },
  mounted() {
    
  },
  methods: {
    async initData () {
      // const result = await getBannerListing('3');
      // this.bannerList = result.data.list;
      try {
        const solutionsDatalist = await getDataList(localStorage.getItem('pageId'));
        const homeDatalist = await getDataList('1');
        // 数据验证
        if (solutionsDatalist && solutionsDatalist.data && solutionsDatalist.data.list) {
          this.solutionsList = solutionsDatalist.data.list;
        } else {
          console.warn('获取的数据为空或格式不正确');
          this.solutionsList = [];
        }
        if (homeDatalist && homeDatalist.data && homeDatalist.data.list) {
          this.treatmentsKomo = homeDatalist?.data?.list.find(item => item.code === 'komo_solutions')?.value?.[0] ?? {};
          console.log(this.treatmentsKomo)
        } else {
          this.treatmentsKomo = {};
        }
      } catch (error) {
        console.error('数据加载失败:', error);
        this.solutionsList = []; // 设置为空数组防止错误
        this.treatmentsKomo = {};
      } finally {
        // 数据加载完成后重新初始化动画观察器
        this.$nextTick(() => {
          this.initIntersectionObserver()
        });
      }
    },
    goToTreatments() {
      this.$router.push('/solutions');
    },
    initIntersectionObserver () {
      // 获取所有需要观察的元素（包括图片和文字）
      const imageElements = this.$el.querySelectorAll('.kb-enabled');
      const textElements = this.$el.querySelectorAll('[data-animate]');
      const animateUpElements = this.$el.querySelectorAll('.img-animate-up .kb-animate-up');
      const allElements = [...imageElements, ...textElements, ...animateUpElements];
      
      if (allElements.length > 0) {
        // 移除所有元素的初始动画类
        imageElements.forEach(element => {
          element.classList.remove('in-viewport');
        });
        
        textElements.forEach(element => {
          element.classList.remove('animate-trigger');
        });
        
        animateUpElements.forEach(element => {
          element.classList.remove('in-viewport');
        });
        
        // 创建交叉观察器
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const element = entry.target;
            
            if (entry.isIntersecting) {
              // 元素进入视口
              // 如果是图片元素
              if (element.classList.contains('kb-enabled')) {
                element.classList.add('in-viewport');
              } 
              // 如果是文字元素
              else if (element.hasAttribute('data-animate')) {
                // 添加动画触发类
                element.classList.add('animate-trigger');
              }
              // 如果是kb-animate-up元素
              else if (element.classList.contains('kb-animate-up')) {
                element.classList.add('in-viewport');
              }
            } else {
              // 元素离开视口（支持重复动画）
              if (element.classList.contains('kb-enabled')) {
                element.classList.remove('in-viewport');
              } else if (element.hasAttribute('data-animate')) {
                element.classList.remove('animate-trigger');
              } else if (element.classList.contains('kb-animate-up')) {
                element.classList.remove('in-viewport');
              }
            }
          });
        }, {
          threshold: 0.1, // 当10%的元素可见时触发
          rootMargin: '0px 0px -50px 0px' // 提前50px触发
        });
        
        // 开始观察所有元素
        allElements.forEach(element => {
          observer.observe(element);
        });
      }
    }
  }
}
</script>
<style scoped lang="scss">
.treatments{
  padding: var(--nav-max-height) 0 0;
  display: block;
}
.treatments-section{
  width: 100%;
}
.treatments-title-cont{
  padding-top: var(--padding-section-top);
  padding-bottom: var(--padding-section-bottom);
}
.treatments-title-cont-text{
  max-width: 920px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: rgba(66 43 32 / 1.0);
}
.treatments-title-cont-text1{
  padding-bottom: 20px;
}
.treatments-title-cont-text1 h2{
  font-size: 30px;
  text-align: center;
  margin: 0;
}
.treatments-title-cont-text2{
  padding-bottom: 0;
  font-size: 14px;
}

.treatments-cont1{
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.treatments-cont1-cont{
  position: relative;
  display: inline-block;
  width: 100%;
  vertical-align: top;
  text-align: left;
}
.treatments-cont1-cont-left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  float: left;
  min-height: 1px;
  vertical-align: top;
  width: 100%;
}
.kb-enabled{
  overflow: hidden;
}
.cont1-img{
  text-align: left;
}
.responsive-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.responsive-image-wrapper5{
  padding: var(--frame);
  background: #edeceb;
}
.responsive-image-wrapper img{
  display: block;
  border: 0 none;
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: cover;
  object-position: 50.0% 50.0% !important;
  aspect-ratio: auto 984 / 1229;
}
/* 图片占位符样式 */
.image-placeholder {
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.image-placeholder::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  animation: loading 1.5s infinite;
}

.placeholder-content {
  text-align: center;
  z-index: 1;
}

.placeholder-icon {
  font-size: 24px;
  color: #999;
  margin-bottom: 10px;
}

.placeholder-text {
  font-size: 14px;
  color: #999;
}

@keyframes loading {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.treatments-cont1-cont-cont ::v-deep(h2){
  font-size: var(--h2-size);
  margin-bottom: 15px;
}
.treatments-cont1-cont-cont ::v-deep(h4){ 
  font-size: var(--h4-size);
}
.treatments-cont1-cont-right-inner div{
  text-align: left;
}
.treatments-cont1-cont-right-inner div:nth-child(2){
  margin-bottom: 0;
}
.treatments-cont1-cont-cont ::v-deep(p) {
  margin-top: 15px;
  line-height: 1.6;
  font-size: var(--base-font-size);
  font-family: var(--body-font-stack);
  font-weight: var(--body-font-weight);
  font-style: var(--body-font-style);
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
}
:root{
  --padding-section-top: 30px;
}
.treatments-section-kong{
  padding-top: var(--padding-section-top);
  padding-bottom: var(--padding-section-bottom);
}

/* Home Treatments 开始 */
.treatments-content {
    padding: 0 60px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 5px;

    .item {
        overflow: hidden;
        position: relative;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
        }

        .content {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            padding: 30px;
            display: flex;
            justify-content: flex-end;
            /* 水平靠右 */
            align-items: flex-end;
            /* 垂直靠下 */
        }

        .content-title {
            color: #ffffff;
            font-size: 30px;
            text-align: right;
        }

        .content-btn {
            margin-top: 10px;
            width: 180px;
            height: 40px;
            line-height: 40px;
            background: #422b20;
            border-radius: 40px;
            text-align: center;
            color: #e8e2d9;
            font-family: var(--body-font-stack);
            font-size: 14px;

            position: relative;
            /* 关键：让伪元素相对它定位 */
            overflow: hidden;
            /* 可选：把超出的光带隐藏得更干净 */
            cursor: pointer;
            transition: background .3s;
            /* 顺手加个背景色过渡 */
        }

        .content-btn::after {
            content: '';
            position: absolute;
            top: 0;
            left: 150%;
            width: 200%;
            height: 100%;
            background: linear-gradient(90deg,
                    transparent,
                    hsla(0, 0%, 100%, .25),
                    transparent);
            transform: skew(-20deg);
            pointer-events: none;
            transition: left .6s ease-out;
        }

        .content-btn:hover::after {
            left: -150% !important;
            /* 保险写法；如仍无效，继续看下面 */
        }

        p {
          margin-top: 15px;
          line-height: 1.6;
          font-size: var(--base-font-size);
          font-family: var(--body-font-stack);
          font-weight: var(--body-font-weight);
          font-style: var(--body-font-style);
          -webkit-font-smoothing: antialiased;
          -webkit-text-size-adjust: 100%;
        }
    }



    .item:nth-child(1) {
        grid-column: span 3;
        height: 30vw;
    }

    .item:nth-child(2) {
        grid-column: span 3;
        height: 30vw;
    }

    .item:nth-child(3) {
        grid-column: span 2;
        height: 40vw;
        background: #223d33;

        .content {
            align-items: center;
            justify-content: flex-start;

            h2 {
                text-align: left;
            }

            p {
                color: #ffffff;
                font-size: 15px;
                font-family: var(--body-font-stack);
            }
        }
    }

    .item:nth-child(4) {
        grid-column: span 2;
        height: 40vw;
    }

    .item:nth-child(5) {
        grid-column: span 2;
        height: 40vw;

        img {
            // transform: scaleX(-1);
        }
    }


}

@media screen and (min-width: 768px) {
    .treatments-cont1-cont {
      display: flex;
    }
    .treatments-cont1-cont-cont{
      width: 50%;
    }
    .treatments-cont1-cont-right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: #e8e2d9;
    }
    .treatments-cont1-cont-right-inner{
      padding: 0;
      width: max-content;
      max-width: 75%;
      margin: 0 auto;
      color: var(--font-color);
    }
    .treatments-cont4-cont-right-inner{
      color: #ffffff;
    }
    .treatments-cont5-cont-right-inner{
      padding:30px 0;
    }
    .cont2-right-bk{
      background: #ffffff;
    }
    .cont3-right-bk{
      background: #efcd97;
    }
    .cont4-right-bk{
      background:#64715d;
    }

    /* 图片动画 - 从大变小 */
    .kb-enabled > * {
      transform: translate3d(.25rem, .12rem, .25rem) scale(1.06);
      transform-origin: left center;
      transition: transform 2s ease;
    }
    
    /* 添加延迟，确保动画触发 */
    .kb-enabled.in-viewport > * {
      animation: scaleDown 2s ease forwards;
      transform-origin: left center;
    }
    
    .treatments-content{
      padding-top: 60px;
      padding-bottom: 60px;
    }
}
.h2, h2 {
  font-size: var(--h2-size)!important;
}
@media (prefers-reduced-motion: reduce) {
  .kb-enabled > * {
    transition: none !important;
  }
}
@keyframes scaleDown {
  from {
    transform: translate3d(.25rem, .12rem, .25rem) scale(1.06);
    transform-origin: left center;
  }
  to {
    transform: translate3d(0, 0, 0) scale(1);
    transform-origin: left center;
  }
}
@media (max-width: 1115px){
  .treatments{
    padding: var(--nav-1115-height) 0 0;
  }
}
@media (max-width: 990px){
  .treatments{
    padding: var(--nav-990-height) 0 0;
  }
}
@media screen and (max-width: 768px) {
  .treatments-cont1-cont{
    display: flex;
    flex-direction: column;
  }
  .treatments-cont1-cont-right-inner{
    padding: 15px 30px;
    text-align: center;
  }
  .treatments-cont1-cont-right-inner div{
    text-align: center;
  }
  .treatments-cont1-cont-right-inner{
    background: #e8e2d9;
  }
  .treatments-cont1-cont-right-inner{
    color: var(--font-color);
  }
  .cont2-right-bk,.treatments-cont1-cont-right-inner{
    background: #ffffff;
  }
  .cont3-right-bk,.treatments-cont3-cont-right-inner{
    background: #efcd97;
  }
  .cont4-right-bk,.treatments-cont4-cont-right-inner{
    background:#64715d;
    color: #ffffff;
  }
  .treatments-cont5-cont-right-inner{
    background:#e8e2d9;
    padding: 15px 30px;
  }
  .treatments-cont5-cont{
    flex-direction: column-reverse;
  }
  .image-placeholder {
    height: 200px;
  }
  
  .placeholder-icon {
    font-size: 18px;
  }
  
  .placeholder-text {
    font-size: 12px;
  }
  .treatments-content {
        grid-template-columns: 1fr;
        padding: 15px;

        .item:nth-child(1) {
            height: 60vw;
        }

        .item:nth-child(2) {
            height: 60vw;

            .content {
                align-items: flex-start;
                justify-content: flex-start;

                .content-title {
                    text-align: left;
                    font-size: 22px;
                }
            }
        }

        .item:nth-child(3) {
            height: 60vw;
            padding: 10px 0;
            h2 {
              font-weight: 600;
            }
        }

        .item:nth-child(4) {
            height: 100vw;
        }

        .item:nth-child(5) {
            height: 100vw;
        }

  }
  .treatments-cont1-cont-cont ::v-deep(h2){
    font-size: var(--h2-size);
    margin-bottom: 15px;
    font-weight: 600;
  }
  .treatments-cont1-cont-right-inner ::v-deep(li){
    text-align: left;
  }
}
@media (max-width: 300px) {
  .treatments-content {
    grid-template-columns: 1fr;
    padding: 0 15px;

    .item:nth-child(3) {
      height: 100vw;
      padding: 10px 0;
    }
  }
}
/* 图片动画 - 从下到上 */
.animate-up {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.8s ease, transform 0.8s ease;
}

.kb-animate-up.in-viewport.animate-up {
    opacity: 1;
    transform: translateY(0);
}

.img-animate-up .item:nth-child(1) {
    transition-delay: 0s;
}

.img-animate-up .item:nth-child(2) {
    transition-delay: 0.15s;
}

.img-animate-up .item:nth-child(3) {
    transition-delay: 0.3s;
}

.img-animate-up .item:nth-child(4) {
    transition-delay: 0.45s;
}

.img-animate-up .item:nth-child(5) {
    transition-delay: 0.6s;
}

</style>